export const SMART_EDIT_OVER_TIMES_REQUEST = 'SMART_EDIT_OVER_TIMES_REQUEST';
export const SMART_EDIT_OVER_TIMES_SUCCESS = 'SMART_EDIT_OVER_TIMES_SUCCESS';
export const SMART_EDIT_OVER_TIMES_FAILURE = 'SMART_EDIT_OVER_TIMES_FAILURE';
export const SMART_EDIT_OVER_TIMES_LOADING = 'SMART_EDIT_OVER_TIMES_LOADING';